import * as yup from 'yup';

const validationSchemaSellBuy = yup.object({
  currencyTitle: yup
    .string()
    .required('Обязательно к заполнению'),
  currencyValue: yup
    .number()
    .min(0.01, 'Минимальное занечение 0.01')
    .required('Обязательно к заполнению'),
  totalCash: yup
    .number()
    .min(0.01, 'Минимальное занечение 0.01'),
  sum: yup
    .number()
    .min(0.01, 'Минимальное занечение 0.01')
    .required('Обязательно к заполнению'),
  comment: yup
    .string()
});

export default validationSchemaSellBuy;
